// Горячие клавиши матча (пробел — пропуск хода отрядом, Enter — завершение
// этапа) не должны срабатывать там, где клавиша уже занята: в полях ввода она
// печатает, а модалки и карточки фракции и политики закрываются Enter и
// пробелом (useCloseOnEnterSpace)
export const checkIfHotkeyBelongsToPage = (event) => {
  const target = event.target;
  if (target && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName))) {
    return true;
  }
  return Boolean(document.querySelector('.modal-window_overlay, .faction-card-overlay'));
};
